// Centralized data-testid registry to keep them unique & meaningful.
export const TID = {
    nav: {
        logo: "nav-logo",
        home: "nav-link-home",
        jobs: "nav-link-jobs",
        platform: "nav-link-platform",
        talent: "nav-link-talent",
        jobSeekers: "nav-link-job-seekers", // legacy alias
        employers: "nav-link-employers",
        jobBoard: "nav-link-job-board", // legacy alias
        pricing: "nav-link-pricing",
        about: "nav-link-about",
        community: "nav-link-community",
        resources: "nav-link-resources",
        contact: "nav-link-contact",
        mobileToggle: "nav-mobile-toggle",
        adminLink: "nav-link-admin",
    },
    home: {
        heroFindJob: "home-cta-find-opportunity",
        heroHireTalent: "home-cta-hire-talent",
        finalCtaSeeker: "home-final-cta-seeker",
        finalCtaEmployer: "home-final-cta-employer",
    },
    jobSeekers: {
        uploadName: "js-upload-name",
        uploadEmail: "js-upload-email",
        uploadPhone: "js-upload-phone",
        uploadCity: "js-upload-city",
        uploadRole: "js-upload-desired-position",
        uploadYears: "js-upload-years-experience",
        uploadLanguages: "js-upload-languages",
        uploadLinkedin: "js-upload-linkedin",
        uploadWorkAuth: "js-upload-work-auth",
        uploadSalary: "js-upload-desired-salary",
        uploadAvailability: "js-upload-availability",
        uploadJobOnsite: "js-upload-job-onsite",
        uploadJobHybrid: "js-upload-job-hybrid",
        uploadJobRemote: "js-upload-job-remote",
        uploadResumeFile: "js-upload-resume-file",
        uploadResumeFileLabel: "js-upload-resume-file-label",
        uploadNotes: "js-upload-notes",
        uploadSubmit: "js-upload-submit",
        aiResumeText: "ai-resume-text",
        aiRole: "ai-resume-target-role",
        aiSubmit: "ai-resume-submit",
        aiResult: "ai-resume-result",
    },
    employers: {
        company: "emp-company",
        contactName: "emp-contact-name",
        email: "emp-email",
        phone: "emp-phone",
        role: "emp-role-needed",
        empType: "emp-employment-type",
        location: "emp-location",
        details: "emp-details",
        submit: "emp-submit",
    },
    jobBoard: {
        search: "jobs-search",
        location: "jobs-location",
        type: "jobs-type",
        industry: "jobs-industry",
        clear: "jobs-clear-filters",
        card: (id) => `job-card-${id}`,
        apply: (id) => `job-apply-${id}`,
        applyDialogSubmit: "job-apply-submit",
        applyName: "job-apply-name",
        applyEmail: "job-apply-email",
        applyPhone: "job-apply-phone",
        applyCover: "job-apply-cover",
    },
    contact: {
        name: "contact-name",
        email: "contact-email",
        subject: "contact-subject",
        message: "contact-message",
        submit: "contact-submit",
    },
    admin: {
        email: "admin-email",
        password: "admin-password",
        loginBtn: "admin-login-btn",
        logout: "admin-logout",
        newJobBtn: "admin-new-job",
        jobTitle: "admin-job-title",
        jobCompany: "admin-job-company",
        jobLocation: "admin-job-location",
        jobSalary: "admin-job-salary",
        jobType: "admin-job-type",
        jobIndustry: "admin-job-industry",
        jobDescription: "admin-job-description",
        jobRequirements: "admin-job-requirements",
        jobSave: "admin-job-save",
        jobDelete: (id) => `admin-job-delete-${id}`,
        jobEdit: (id) => `admin-job-edit-${id}`,
        resumeView: (id) => `admin-resume-view-${id}`,
        resumeDownload: (id) => `admin-resume-download-${id}`,
    },
};
